import { render, staticRenderFns } from "./DoctorSurgeryHistory.vue?vue&type=template&id=2f2dddba&scoped=true"
import script from "./DoctorSurgeryHistory.vue?vue&type=script&lang=js"
export * from "./DoctorSurgeryHistory.vue?vue&type=script&lang=js"
import style0 from "./DoctorSurgeryHistory.vue?vue&type=style&index=0&id=2f2dddba&prod&lang=scss&scoped=true"
import style1 from "./DoctorSurgeryHistory.vue?vue&type=style&index=1&id=2f2dddba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2dddba",
  null
  
)

export default component.exports